import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BackgroundJobsService, BackgroundJob } from '@core/services/background-jobs.service';
import { Observable } from 'rxjs';
import { Router } from '@angular/router';

@Component({
  selector: 'app-notification-center',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './notification-center.component.html',
  styleUrls: ['./notification-center.component.scss']
})
export class NotificationCenterComponent implements OnInit {
  jobs$: Observable<BackgroundJob[]>;
  isOpen = false;
  activeJobsCount = 0;

  constructor(
    public backgroundJobsService: BackgroundJobsService,
    private router: Router
  ) {
    this.jobs$ = this.backgroundJobsService.jobs$;
  }

  ngOnInit() {
    this.jobs$.subscribe(jobs => {
      this.activeJobsCount = jobs.filter(job => 
        job.status === 'pending' || job.status === 'processing'
      ).length;
    });
  }

  toggleDropdown() {
    this.isOpen = !this.isOpen;
  }

  closeDropdown() {
    this.isOpen = false;
  }

  getProgressPercentage(job: BackgroundJob): number {
    if (job.total_jobs === 0) return 0;
    return Math.round((job.processed_jobs / job.total_jobs) * 100);
  }

  getStatusIcon(job: BackgroundJob): string {
    switch (job.status) {
      case 'pending':
      case 'processing':
        return 'ri-loader-4-line';
      case 'completed':
        return 'ri-checkbox-circle-line';
      case 'failed':
        return 'ri-close-circle-line';
      default:
        return 'ri-information-line';
    }
  }

  getStatusClass(job: BackgroundJob): string {
    switch (job.status) {
      case 'pending':
      case 'processing':
        return 'text-primary';
      case 'completed':
        return 'text-success';
      case 'failed':
        return 'text-danger';
      default:
        return 'text-muted';
    }
  }

  navigateToBatch(batchId: string) {
    this.closeDropdown();
    this.router.navigate(['/pages/afp-jobs', batchId]);
  }

  removeJob(jobId: string, event: Event) {
    event.stopPropagation();
    this.backgroundJobsService.removeJob(jobId);
  }

  clearCompleted() {
    this.backgroundJobsService.clearCompletedJobs();
  }

  getTimeAgo(date: Date): string {
    const now = new Date();
    const diff = now.getTime() - new Date(date).getTime();
    const minutes = Math.floor(diff / 60000);
    const hours = Math.floor(diff / 3600000);
    
    if (minutes < 1) return 'Just now';
    if (minutes < 60) return `${minutes}m ago`;
    if (hours < 24) return `${hours}h ago`;
    return `${Math.floor(hours / 24)}d ago`;
  }
}
